<template>
    <div style="height:100%;overflow-y: auto;color:#444">
        <div class="bg-field">
            <div class="project-img">
                <img :src="data.imgUrl"/>
            </div>
            <div class="vertical-center" style="margin-top: 10px;text-align: center;font-size: 20px">
                {{data.name}}
            </div>
        </div>
        <div class="text-field" ref="textField">
            <div class="space-between" style="align-items: center">
                <span class="tag"></span>
                <div style="flex:1;font-size:15px">价格</div>
                <div style="font-size: 20px">￥{{data.price}}</div>
            </div>
            <div class="space-between" style="align-items: center;margin-top: 30px">
                <span class="tag"></span>
                <div style="flex:1;font-size:15px">治疗诊所</div>
            </div>
            <div></div>
            <div class="space-between" style="align-items: center;margin-top: 30px">
                <span class="tag"></span>
                <div style="flex:1;font-size:15px">诊疗项目介绍</div>
            </div>
            <div style="margin-top: 20px" v-html="data.detail"></div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast} from 'mint-ui';

    export default {
        data() {
            return {
                location: location,
                data: {
                    id: "",
                    imgUrl: "",
                    name: "",
                    pinyinCode: "",
                    price: "",
                    productTypeId: "",
                    unit: ""
                }
            }
        },
        methods: {},
        created() {
            utils.apply(this.data, this.$store.state.transData || {})
            console.log(this.$store.state.transData);
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/common.css";

    .bg-field {
        background: rgb(65, 160, 242);
        color: white;
        padding: 20px 20px 50px 35px;
    }

    .svg-icon {
        fill: rgb(255, 255, 255);
        vertical-align: top;
    }

    .text-field {
        background: white;
        box-shadow: 0 0 3px rgba(0, 0, 0, .4);
        border-radius: 8px;
        margin: -30px 20px 20px 20px;
        padding: 20px;
    }

    .project-img {
        width: 70px;
        height: 70px;
        margin: 0 auto;
        background: white;
        border-radius: 100px;
        position: relative;
        overflow: hidden;
        img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }
    }

    span.tag{
        width: 5px;
        height:14px;
        background: rgb(65, 160, 242);
        margin-right: 8px;
    }
</style>